import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import translationDe from "./locales/main/de.json";
import translationEng from "./locales/main/en.json";

// the translations
const resources = {
  de: {
    translation: translationDe,
  },
  en: {
    translation: translationEng,
  },
};

const language = localStorage.getItem("i18nextLng");
/*if (!language) {
   localStorage.setItem("i18nextLng", "de"); 
}*/

i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem("i18nextLng")/* || "de"*/,
    fallbackLng: "de", // use de if detected lng is not available

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
